import { useState } from "react";
import { PLANS, WHERE_WE_ARE, FAQ } from "@/site/content";
import { fmtMoney } from "@/site/api";
import { track } from "@/site/analytics";

export function PlanCards({ showSeats = true }) {
  const [seats, setSeats] = useState(8);
  const p = PLANS[0];
  const extraSeats = Math.max(0, seats - p.includedSeats);
  const price = p.basePrice + p.perSeat * extraSeats;
  return (
    <div>
      {showSeats && (
        <div className="seatbar">
          <label htmlFor="seats">How many people will use it?</label>
          <input id="seats" className="range" style={{ maxWidth: 260 }} type="range" min="1" max="50" value={seats} onChange={(e) => setSeats(Number(e.target.value))} data-testid="seats-slider" />
          <output htmlFor="seats" data-testid="seats-output">{seats} seats</output>
        </div>
      )}
      <div className="plans plans--single">
        <div className="plan" data-testid={`plan-${p.id}`}>
          <div><div className="plan__name">{p.name}</div><div className="body" style={{ marginTop: 4 }}>{p.blurb}</div></div>
          <div className="plan__price num">{fmtMoney(price)} <small>/ month, billed monthly</small></div>
          <ul className="plan__list">{p.features.map((f) => <li key={f}>{f}</li>)}</ul>
          <a href="#pilot" className="btn btn--primary" onClick={() => track("cta_click", { where: `plan_${p.id}` })} data-testid={`plan-cta-${p.id}`}>{p.cta}</a>
        </div>
      </div>
    </div>
  );
}

export function WhereWeAre() {
  const cls = (s) => `status status--${s.toLowerCase().replace(/\s.*/, "")}`;
  return (
    <div className="wwa" data-testid="where-we-are">
      <div className="wwa__head"><div><div className="eyebrow">Where we are</div><div style={{ fontWeight: 600, fontSize: 18 }}>What ships today, what is in pilot, what isn't done.</div></div><div className="mono" style={{ fontSize: 12, color: "var(--faint)" }}>Updated {WHERE_WE_ARE.updated}</div></div>
      <div className="wwa__items">
        {WHERE_WE_ARE.items.map((it) => (
          <div className="wwa__item" key={it.label}><div className="wwa__label">{it.label}<span className={cls(it.status)}>{it.status}</span></div><div className="body" style={{ fontSize: 14 }}>{it.text}</div></div>
        ))}
      </div>
    </div>
  );
}

export function FaqList({ groups = FAQ }) {
  const [open, setOpen] = useState(null);
  return (
    <div data-testid="faq">
      {groups.map((g) => (
        <div className="faq__group" key={g.group}>
          <div className="faq__g">{g.group}</div>
          {g.items.map((it) => {
            const id = `${g.group}-${it.q}`; const isOpen = open === id;
            return (
              <div className="faq__item" key={id}>
                <button className="faq__q" aria-expanded={isOpen} onClick={() => { setOpen(isOpen ? null : id); if (!isOpen) track("faq_open", { q: it.q.slice(0, 60) }); }}>
                  <span>{it.q}</span><span className="i" aria-hidden="true">{isOpen ? "−" : "+"}</span>
                </button>
                {isOpen && <div className="faq__a">{it.a}</div>}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}
